import { Body, SectionTitle } from "@sprout/typography.tsx";
import LoadingSkeleton from "./loading_skeleton.tsx";

type Props = {
  loading?: boolean;
  company: string;
  title: string;
};
const TitleCompany = ({ loading, company, title }: Props) => {
  return loading ? (
    <>
      <LoadingSkeleton className="h-4 w-[200px] mb-1" />
      <LoadingSkeleton className="h-4 w-[200px]" />
    </>
  ) : (
    <>
      <SectionTitle className="line-clamp-2" title={title}>
        {title}
      </SectionTitle>
      <Body>{company}</Body>
    </>
  );
};

export default TitleCompany;
